// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./styles.css";
import uuid from "uuid";
import withValidation from "../with-validation";

const excludedProps = ["className", "errorMessage", "isError", "labelText", "placeholder"];
const filterProps = _props => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {}),
    id: _props.id || uuid()
});


class DropDown extends Component {


    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        className: PropTypes.string,
        disabled: PropTypes.bool,
        errorMessage: PropTypes.string,
        isError: PropTypes.bool,
        labelText: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        style: PropTypes.object,
        value: PropTypes.any
    };

    static defaultProps = {
        disabled: false,
        isError: false,
        required: false,
        errorMessage: "Error"
    };


    render() {
        const { disabled, errorMessage, isError, required, labelText, placeholder } = this.props;
        const componentClass = `drop-down${required ? " is-required" : ""}${isError ? " is-error" : ""}${disabled ? " is-disabled" : ""}`;
        const inputProps = filterProps(this.props);
        return (
            <label
                className={ componentClass }
                htmlFor={ inputProps.id }
            >
                <span className="drop-down--label-text">{labelText}</span>
                <span className={ "drop-down--error-message" }>{errorMessage}</span>
                <select className={ "drop-down--select-control" } { ...inputProps }>
                    <option disabled={ true } value={ "" }>{placeholder || "Select"}</option>
                    {this.props.children}
                </select>

            </label>
        );
    }
}


export default withValidation(DropDown);